import Cookies from "js-cookie"
import { Locale, locales } from "../../locales"

export const changePreferredLang = (locale: Locale): void => {
  // Dynamically get the list of valid locales from locales.ts
  if (!locales.includes(locale))
    throw new Error(`Invalid locale: ${locale}. Valid values are: ${locales.join(", ")}`)

  Cookies.set("wg_preferred_lang", locale)
}
